import { useCountryParam, useMutateWatchlists } from 'utils/hooks';
import { FiPlusCircle } from 'react-icons/fi';
import SoftButton from './SoftButton';
import styled from 'styled-components';
import { useHistory } from 'react-router';
import { v4 as uuid } from 'uuid';

const IconLeft = styled(FiPlusCircle)`
    color: ${({ theme }) => theme.purple_1};
`;
const SoftButtonGrayText = styled(SoftButton)`
    color: ${({ theme }) => theme.gray_2};
`;

function NewWatchlistButton() {
    const { mutateToWithCountryParam } = useCountryParam();
    const history = useHistory();
    const { add } = useMutateWatchlists();
    const onClick = () => {
        const id = uuid();
        add({ id, data: { name: 'New Watchlist' } });
        history.push(mutateToWithCountryParam(`/watchlist/${id}`));
    };

    return (
        <SoftButtonGrayText
            IconLeft={IconLeft}
            size="sm"
            onClick={onClick}
            mixpanelContext="NewWatchlist"
        >
            New Watchlist
        </SoftButtonGrayText>
    );
}

export default NewWatchlistButton;
